export function buildPersonPath(personId: string, subpath?: string) {
    const base = `/org/people/${personId}`;

    return subpath ? `${base}/${subpath}` : base;
}
